import { getAnalyticsContext } from './context'
import { gtagCall } from './queue'
import type { AnalyticsEventNameT, AnalyticsParamsT, AnalyticsPrimitiveT } from './types'

export * from './types'
export {
  buildItem,
  newTransactionId,
  trackBeginCheckout,
  trackPurchase,
  trackPurchaseError,
  trackSelectItem,
  trackUpsellDismiss,
  trackViewItem,
} from './ecommerce'
export { clearAnalyticsContext, setAnalyticsContext } from './context'

declare global {
  interface Window {
    gtag?: (...args: unknown[]) => void
  }
}

const stripUndefined = (params: Record<string, unknown>): Record<string, unknown> => {
  const out: Record<string, unknown> = {}
  for (const [key, value] of Object.entries(params)) {
    if (value === undefined || value === null) continue
    if (typeof value === 'string' && value === '') continue
    out[key] = value
  }
  return out
}

export const track = (event: AnalyticsEventNameT, params?: AnalyticsParamsT) => {
  const merged = stripUndefined({ ...getAnalyticsContext(), ...params })
  gtagCall('event', event, merged)
}

export const setGa4UserId = (userId: string) => {
  gtagCall('set', { user_id: userId })
}

export const clearGa4UserId = () => {
  gtagCall('set', { user_id: null })
}

export const setUserProperties = (props: Record<string, AnalyticsPrimitiveT>) => {
  const clean = stripUndefined(props)
  if (Object.keys(clean).length === 0) return
  gtagCall('set', 'user_properties', clean)
}

export const sendGa4PageView = (path?: string) => {
  if (typeof window === 'undefined') return
  track('page_view', {
    page_location: window.location.href,
    page_path: path ?? window.location.pathname,
    page_title: document.title,
    page_referrer: document.referrer || undefined,
  })
}

export const errorType = (err: unknown): string => {
  if (err === null || err === undefined) return 'unknown'
  if (typeof err === 'string') return err.slice(0, 60)
  if (err instanceof Error) return (err.name || 'Error').slice(0, 60)
  if (typeof err === 'object') {
    const maybe = err as { name?: string; code?: string; status?: number; message?: string }
    if (maybe.code) return String(maybe.code).slice(0, 60)
    if (maybe.status) return `http_${maybe.status}`
    if (maybe.name) return String(maybe.name).slice(0, 60)
    if (maybe.message) return String(maybe.message).slice(0, 60)
  }
  return 'unknown'
}

export const startTimer = () => {
  const startedAt = Date.now()
  return () => Date.now() - startedAt
}
